var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCallUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#A9A9A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7937 20.15C26.7937 21.7119 25.5275 22.9785 23.9652 22.9785C22.4029 22.9785 21.1367 21.7119 21.1367 20.15C21.1367 18.5882 22.4029 17.3216 23.9652 17.3216C25.5275 17.3216 26.7937 18.5882 26.7937 20.15Z",
    stroke: "#808080",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9048 26.4043C19.7179 24.4173 21.66 23.007 23.9421 22.9806C26.2579 22.9537 28.2571 24.3597 29.0952 26.3755",
    stroke: "#808080",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 16.5321V28.103C34.0001 29.1209 33.1581 29.9463 32.1202 29.9463H15.8799C14.8415 29.9463 14.0005 29.1209 14.0005 28.103V15.8421C14.0005 14.8246 14.8415 13.9997 15.8799 13.9997H31.4165",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6068 33.9424H18.3931",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8799 29.9465V33.3008",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1196 29.9465V33.3008",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.3291H33.9996",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallUnavailable);
export default __webpack_public_path__ + "static/media/video-call-unavailable.8af0358491ae5293bd9f98e505715cc4.svg";
export { ForwardRef as ReactComponent };